export const getCrop = (cropId) => ({ crops }) =>
crops.cropsList.find(({ id }) => id === cropId);